/** @format */

import {v4} from 'uuid';

import {Space, SpaceList} from 'pages/Home/DigitalCast/models/spaces';

const defaultSpace = (): SpaceList => {
  const id = v4();

  const newSpace: Space = {
    id,
    title: 'Рабочее пространство 1',
    order: 0,
    widgetsBoardSelected: ['budget', 'shows', 'clicks', 'ctr', 'cpc'],
    widgetsSettings: {
      budget: {
        calcMethod: 'day',
      },
      shows: {
        calcMethod: 'day',
      },
      clicks: {
        calcMethod: 'day',
      },
      ctr: {},
      cpc: {},
    },
    widgetsMenuSelected: ['budget', 'shows', 'clicks', 'ctr', 'cpc'],
    chartSelected: {
      current: ['budget', 'shows', 'clicks', 'ctr', 'cpc'],
      previous: [],
    },
  };

  return {
    [id]: newSpace,
  };
};

export default defaultSpace;
